import { render, staticRenderFns } from "./MyPaso.vue?vue&type=template&id=f221c8b4&scoped=true"
import script from "./MyPaso.vue?vue&type=script&lang=js"
export * from "./MyPaso.vue?vue&type=script&lang=js"
import style0 from "./MyPaso.vue?vue&type=style&index=0&id=f221c8b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f221c8b4",
  null
  
)

export default component.exports